var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"variant":_vm.variant,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon-plus',{attrs:{"scale":"1.6"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }